import { defineMessages } from '@transcend-io/internationalization';

export const errorBoundaryMessages = defineMessages(
  'privacy-center.containers.ErrorBoundary.errorBoundary',
  {
    back: {
      defaultMessage: 'Go back',
    },
    header: {
      defaultMessage: 'Something went wrong...',
    },
  },
);
